import * as Immutable from 'immutable';
import * as React from 'react';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';

import { getLastNotifications } from '../../../actions/Dashboard/NotificationsActions';
import { makeItScroll } from '../../../actions/MessagesActions';
import { StateType } from '../../../reducers';
import {
  notificationsDataSelector,
  notificationsIsFetchingSelector,
} from '../../../reducers/DashboardReducer/NotificationsReducer/NotificationsSelector';
import { DispatchConnect } from '../../../types/';

import { NotificationsPropsGeneric, NotificationsStateDispatchers, NotificationsStateProps } from './types';
import NotificationsMain from './NotificationsMain';
import analytics from '../../../shared/services/analytics/analytics';

class Notifications extends React.Component<NotificationsPropsGeneric> {
  UNSAFE_componentWillMount() {
    this.props.dispatchGetDashboardNotifications();
  }

  handleMakeItScroll = (id: string, source: string) => {
    this.props.dispatchMakeItScroll(id);
    analytics.trackCustomEvent('click_announcement', { event_category: source, event_label: id });
  };

  render() {
    return (
      <NotificationsMain
        data={this.props.enabledIntro ? Immutable.List() : this.props.data}
        isFetching={this.props.isFetching}
        getLastNotifications={this.props.dispatchGetDashboardNotifications}
        handleMakeItScroll={this.handleMakeItScroll}
      />
    );
  }
}

const mapStateToProps = (state: StateType): NotificationsStateProps => ({
  // @ts-ignore
  data: notificationsDataSelector(state),
  // @ts-ignore
  isFetching: notificationsIsFetchingSelector(state),
});

const mapDispatchToProps = (dispatch: Dispatch<any>): NotificationsStateDispatchers => ({
  dispatchGetDashboardNotifications: async () => dispatch(getLastNotifications()),
  dispatchMakeItScroll: (id: string) => {
    dispatch(makeItScroll(id));
  },
});

export default connect<NotificationsStateProps, DispatchConnect<NotificationsStateDispatchers>, any, StateType>(
  mapStateToProps,
  mapDispatchToProps
)(Notifications);
